module.exports = __webpack_public_path__ + "static/img/xiu_App_QR_Code.ae49268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiu_App_QR_Code.png
// module id = iAmi
// module chunks = 0